import { render, staticRenderFns } from "./MRHome.vue?vue&type=template&id=6ab6cfda&scoped=true&"
import script from "./MRHome.vue?vue&type=script&lang=js&"
export * from "./MRHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab6cfda",
  null
  
)

export default component.exports